import { useIsFocused } from "@react-navigation/native";
import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { useFlags } from "@/utils/launchDarkly";
import { Loader } from "@whoosh/design-system/src/components/display";

import {
  ProfileQueryRenderer,
  ProfileQueryRendererQueryString,
} from "./ProfileQueryRenderer";
import { ProfileQueryRendererQuery } from "./__generated__/ProfileQueryRendererQuery.graphql";

export const ProfileQueryWrapper = () => {
  const isFocused = useIsFocused();
  const { patronLoyalty } = useFlags();
  const [profileQueryRef, loadProfileQuery] =
    useQueryLoader<ProfileQueryRendererQuery>(ProfileQueryRendererQueryString);

  useEffect(() => {
    if (isFocused) {
      loadProfileQuery(
        { patronLoyalty: !!patronLoyalty },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [isFocused, loadProfileQuery, patronLoyalty]);

  return (
    <Suspense fallback={<Loader />}>
      {profileQueryRef ? (
        <ProfileQueryRenderer queryRef={profileQueryRef} />
      ) : null}
    </Suspense>
  );
};
